<div class="app-body animated fadeIn m-0">
  <div class="row justify-content-start m-0 py-3 hide-in-modal" style="width:100%;">
    <div class="col-lg-12 col-md-12 col-sm-12 login-new-details px-5">
      <div class="logo-org">
        <img src="/assets/img/brand/logo-high-original.png" style="width:180px;" />
      </div>
    </div>
  </div>
  <div class="row justify-content-start mx-0 when-as-apage">
    <div class="col-lg-4 col-md-4 col-sm-5 col-12 adjust-width-padding">
      <div class="card try-card card-primary card-outline">
        <div class="card-header p-3">
          <h4 class="card-title">Change Password</h4>
        </div>
        <div class="card-body p-4">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <lib-vio-input [formsData]="changePassword"></lib-vio-input>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <a class="btn btn-profile btn-grad" (click)="saveChangePassword()" [appDisableWhile]="isSubmitting">
            <b><i class="fa fa-solid fa-key mx-1"></i> Change Password</b>
          </a>
          <button type="button" class="btn btn-secondary mx-1 btn-shadow btn-cancel-for-modal" title="Cancel"
            (click)="closeModal()">
            <i class="fa-regular fa-circle-xmark"></i> Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
